$(function () {

  // pulldown init処理
  function pulldownInitFunction(_this) {
    $('.jsPulldownTrigger').removeClass('isActive');
    $('.jsPulldownContents').removeClass('isOpen');
    return _this.off('mouseenter mouseleave');
  }
  // pulldown open処理
  function pulldownOpenFunction(trigger,pulldown) {
    trigger.addClass('isActive');
    pulldown.addClass('isOpen');
  }
  // pulldown close処理
  function pulldownCloseFunction(trigger,pulldown) {
    trigger.removeClass('isActive');
    pulldown.removeClass('isOpen');
  }

  // 複数ファイル時のプルダウントリガー
  $(document).on({
      'touchstart': function() {
        var $this = $(this)
        pulldownInitFunction($this);
      },
      'touchstart mouseenter':function(){
        var $trigger = $(this);
        var $pulldown = $(this).next('.jsPulldownContents');
        pulldownOpenFunction($trigger,$pulldown);
      },
      'mouseleave':function(){
        var $trigger = $(this);
        var $pulldown = $(this).next('.jsPulldownContents');
        pulldownCloseFunction($trigger,$pulldown);
      }
    },
    '.jsPulldownTrigger'
  )

  // プルダウンリストマウスオーバー時にプルダウン表示保持
  $(document).on({
      'touchstart': function() {
        var $this = $(this)
        pulldownInitFunction($this);
      },
      'touchstart mouseenter':function(){
        var $trigger = $(this).closest('.jsPulldownContents').prev('.jsPulldownTrigger');
        var $pulldown = $(this).closest('.jsPulldownContents');
        pulldownOpenFunction($trigger,$pulldown);
      },
      'mouseleave':function(){
        var $trigger = $(this).closest('.jsPulldownContents').prev('.jsPulldownTrigger');
        var $pulldown = $(this).closest('.jsPulldownContents');
        pulldownCloseFunction($trigger,$pulldown);
      }
    },
    '.jsPulldownList'
  )

  // セルに対する見出しのアクティブ制御
  $(document).on({
      'touchstart': function() {
        $('.headList').find('headItem').removeClass('isActive');
        $('.headList').find('item').removeClass('isActive');
        return $(this).off('mouseenter mouseleave');
      },

      'touchstart mouseenter':function(){
        var index = $(this).index();
        $('.jsProdListHeading').find('.jsListHead'+index).addClass('isActive');
      },
      'mouseleave':function(){
        var index = $(this).index();
        $('.jsProdListHeading').find('.jsListHead'+index).removeClass('isActive');
      }
    },
    '.jsCellHover .cell'
  )

  // 見出しエリアの上部フロート
  if ($('.jsProdListHeading').length) {
    var $fixElement = $('.jsProdListHeading');
    var baseFixPoint = $fixElement.offset().top;
    var fixElementHeight = $fixElement.outerHeight()+20;
    var $fixElementNext = $('.jsProdListBody');
    var fixClass = 'isFixed';
    // 要素が追従する処理
    function fixFunction() {
      var windowScrolltop = $(window).scrollTop();
      var scrollLeft = $(window).scrollLeft();
      // スクロールが初期位置を通過しているとき
      if(windowScrolltop >= baseFixPoint) {
        $fixElement.addClass(fixClass);
        $fixElementNext.css('padding-top',fixElementHeight);
        $fixElement.css('left', - $(window).scrollLeft());
      } else {
        $fixElement.removeClass(fixClass).removeAttr('style');
        $fixElementNext.removeAttr('style');
      }
    }
    // 実行文
    $(window).on('load scroll resize', function() {
      if($('body').css('min-width') == '1060px'){
        fixFunction();
      } else {
        $('.jsProdListHeading').removeClass('isFixed');
        $('.jsProdListBody').removeAttr('style');
      }
    });
  }

});